var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87682 3.87681C3.03399 3.87681 1.54005 5.21994 1.54005 6.87683V13.6153C1.54005 15.2722 3.03399 16.6153 4.87682 16.6153H13.0905C14.9333 16.6153 16.4272 15.2722 16.4272 13.6153V6.87683C16.4272 5.21994 14.9333 3.87681 13.0905 3.87681H4.87682ZM0 6.87683C0 4.45524 2.18343 2.49219 4.87682 2.49219H13.0905C15.7838 2.49219 17.9673 4.45524 17.9673 6.87683V13.6153C17.9673 16.0369 15.7838 17.9999 13.0905 17.9999H4.87682C2.18343 17.9999 0 16.0369 0 13.6153V6.87683Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2876 0C5.71291 0 6.05763 0.309955 6.05763 0.692309V3.18462C6.05763 3.567 5.71291 3.87693 5.2876 3.87693C4.86237 3.87693 4.51758 3.567 4.51758 3.18462V0.692309C4.51758 0.309955 4.86237 0 5.2876 0Z",
    fill: "#A8A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6798 0C13.1051 0 13.4498 0.309955 13.4498 0.692309V3.18462C13.4498 3.567 13.1051 3.87693 12.6798 3.87693C12.2546 3.87693 11.9098 3.567 11.9098 3.18462V0.692309C11.9098 0.309955 12.2546 0 12.6798 0Z",
    fill: "#A8A8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.66748 6.64624H17.3V8.03086H0.66748V6.64624Z",
    fill: "#A8A8A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40454 10.6613C4.40454 10.2789 4.74933 9.96899 5.17457 9.96899H5.40046C5.82576 9.96899 6.17049 10.2789 6.17049 10.6613C6.17049 11.0437 5.82576 11.3536 5.40046 11.3536H5.17457C4.74933 11.3536 4.40454 11.0437 4.40454 10.6613Z",
    fill: "#A8A8A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5155 10.6613C7.5155 10.2789 7.86023 9.96899 8.28553 9.96899H9.6818C10.1071 9.96899 10.4518 10.2789 10.4518 10.6613C10.4518 11.0437 10.1071 11.3536 9.6818 11.3536H8.28553C7.86023 11.3536 7.5155 11.0437 7.5155 10.6613Z",
    fill: "#A8A8A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7968 10.6613C11.7968 10.2789 12.1415 9.96899 12.5668 9.96899H12.7927C13.218 9.96899 13.5628 10.2789 13.5628 10.6613C13.5628 11.0437 13.218 11.3536 12.7927 11.3536H12.5668C12.1415 11.3536 11.7968 11.0437 11.7968 10.6613Z",
    fill: "#A8A8A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40454 13.9848C4.40454 13.6024 4.74933 13.2925 5.17457 13.2925H6.83783C7.26313 13.2925 7.60785 13.6024 7.60785 13.9848C7.60785 14.3672 7.26313 14.6771 6.83783 14.6771H5.17457C4.74933 14.6771 4.40454 14.3672 4.40454 13.9848Z",
    fill: "#A8A8A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91174 13.9848C8.91174 13.6024 9.25653 13.2925 9.68177 13.2925H9.90766C10.333 13.2925 10.6777 13.6024 10.6777 13.9848C10.6777 14.3672 10.333 14.6771 9.90766 14.6771H9.68177C9.25653 14.6771 8.91174 14.3672 8.91174 13.9848Z",
    fill: "#A8A8A8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7968 13.9848C11.7968 13.6024 12.1415 13.2925 12.5668 13.2925H12.7927C13.218 13.2925 13.5628 13.6024 13.5628 13.9848C13.5628 14.3672 13.218 14.6771 12.7927 14.6771H12.5668C12.1415 14.6771 11.7968 14.3672 11.7968 13.9848Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCalenderIcon);
export default __webpack_public_path__ + "static/media/disabled-calender-icon.7aafe5d087b5c2f5fb0536ba629c93cd.svg";
export { ForwardRef as ReactComponent };